/**
 * Canonical event types and required fields for dev-mode validation.
 * Not enforced at runtime — only used for console warnings during development.
 */
export const EventTypes = {
  PAGE_VIEW: "page_view",
  CLICK: "click",
  VIDEO_EVENT: "video_event",
  SEARCH: "search",
  ARTICLE_ACTION: "article_action",
  ARTICLE_LINK_CLICK: "article_link_click",
  ARTICLE_RELATED_CLICK: "article_related_click",
};

export const requiredFields = {
  [EventTypes.PAGE_VIEW]: ["page.section"],
  [EventTypes.CLICK]: ["page.section", "interaction.category"],
  [EventTypes.VIDEO_EVENT]: ["page.section", "video.event"],
  [EventTypes.SEARCH]: ["page.section", "search.keyword"],
  [EventTypes.ARTICLE_ACTION]: ["page.section", "interaction.module"],
  [EventTypes.ARTICLE_LINK_CLICK]: ["page.section", "interaction.label"],
  [EventTypes.ARTICLE_RELATED_CLICK]: ["page.section", "interaction.category"],
};

/**
 * Checks nested path existence on an object (e.g. "page.section").
 */
const getNestedValue = (obj, path) =>
  path.split(".").reduce((acc, key) => acc?.[key], obj);

/**
 * Validates an event against requiredFields and logs warnings in dev mode.
 * Returns true if valid (or if no schema exists for the event type).
 */
export const validateEvent = (event) => {
  const fields = requiredFields[event?.event];
  if (!fields) return true;

  const missing = fields.filter(
    (field) => getNestedValue(event, field) === undefined,
  );

  if (missing.length > 0) {
    // eslint-disable-next-line no-console
    console.warn(
      `[dataLayer] Event "${event.event}" missing fields: ${missing.join(", ")}`,
      event,
    );
    return false;
  }
  return true;
};
